var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Secured Page")]),_c('v-card-text',[_c('p',[_vm._v("Welcome to the secured page.")]),_c('v-btn',{on:{"click":_vm.logout}},[_vm._v("Logout")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }